import React from "react";
import { Box, Heading, Text, Button } from "@chakra-ui/react";
import { Link as ScrollLink } from "react-scroll";
import heroImage from "../assets/hero.png";

const HeroSection = () => {
  return (
    <Box
      bgImage={`url(${heroImage})`}
      bgSize={"cover"}
      bgPosition={"center"}
      bgRepeat={"no-repeat"}
      h={"100vh"}
      position={"static"}
      display={"fixed"}
      alignItems={"center"}
      justifyContent={"center"}
      textAlign={"left"}
      px={8}
      w="100%"
    >
      <Box w={{ base: "90%", md: "70%", lg:"70%", xl:"70%" }} textAlign="left">
        <Heading
          as="h1"
          size={{ base: "xl", md: "4xl" }}
          mb={4}
          color="white"
          textShadow="2px 2px 8px rgba(0, 0, 0, 0.5)"
        >
          Soluções Inovadoras
        </Heading>
        <Text
          fontSize={{ base: "lg", md: "2xl" }}
          mb={6}
          color="white"
          textShadow="1px 1px 4px rgba(0, 0, 0, 0.5)"
        >
          Sua fonte para gerenciamento eficiente de empilhadeiras
        </Text>
        <ScrollLink
          to="serviços"
          smooth={true}
          duration={500}
          spy={true}
          offset={-80}
        >
          <Button
            bg="gold.500"
            color="black"
            size="lg"
            borderRadius="0"
            _hover={{ bg: "gold.700" }}
          >
            NOSSOS SERVIÇOS
          </Button>
        </ScrollLink>
      </Box>
    </Box>
  );
};

export default HeroSection;